import React from 'react';
import { Card, CardHeader, Chip } from '@mui/material';
import ColoredUserAvatar from './ColoredUserAvatar';

const ProfileSummaryCard = ({ name, email, role }) => (
  <Card>
    <CardHeader
      avatar={<ColoredUserAvatar name={name} color="primary.main" sx={{ width: 56, height: 56 }} />}
      title={name}
      subheader={email}
      titleTypographyProps={{ variant: 'h6' }}
      action={role && (
        <Chip label={role} color="primary" variant="outlined" size="small" sx={{ mt: 1 }} />
      )}
      sx={{
        '& .MuiCardHeader-content': { minWidth: 0 },
        '& .MuiCardHeader-action': { flexShrink: 0, m: 0 },
      }}
    />
  </Card>
);

export default ProfileSummaryCard;
